export enum EStatusProducao {
  Pendente = 0,
  Produzindo = 1,
  Concluido = 2,
  Interrompido = 3,
  Cancelado = 4,
}
